// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-theme-homestead -> apartment-management-consultants-theme-homestead-milburn -> allegro-d702
// Generated: 2026-08-21T22:01:02.731Z
// Counts: 7 design, 42 content, 37 slot group, 0 collection binding, 7 section, 0 style

export const designOverrides = {
  "design._site.color.accent": {
    "cssVariable": "--vibe-color-accent",
    "overrideType": "FIELD_MAPPING",
    "value": null,
    "mappedField": "property_color_3"
  },
  "design._site.color.surface": {
    "cssVariable": "--vibe-color-surface",
    "overrideType": "FIELD_MAPPING",
    "value": null,
    "mappedField": "property_secondary_color"
  },
  "design._site.color.textMuted": {
    "cssVariable": "--vibe-color-text-muted",
    "overrideType": "VALUE",
    "value": "#303030",
    "mappedField": null
  },
  "design._site.font.accent": {
    "cssVariable": "--vibe-font-accent",
    "overrideType": "VALUE",
    "value": "'DM Sans', sans-serif",
    "mappedField": null
  },
  "design._site.font.body": {
    "cssVariable": "--vibe-font-body",
    "overrideType": "VALUE",
    "value": "'DM Sans', sans-serif",
    "mappedField": null
  },
  "design._site.font.heading": {
    "cssVariable": "--vibe-font-heading",
    "overrideType": "VALUE",
    "value": "'DM Sans', sans-serif",
    "mappedField": null
  },
  "design._site.font.mono": {
    "cssVariable": "--vibe-font-mono",
    "overrideType": "VALUE",
    "value": "'DM Sans', sans-serif",
    "mappedField": null
  }
};

export const contentOverrides = {
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Allegro in Phoenix, experience a vibrant lifestyle surrounded by nature and adventure. Enjoy easy access to South Mountain Park trails, unwind at Oasis Water Park, or ignite your thrill-seeking side at Urban Air Trampoline Park. Live where excitement and leisure seamlessly blend— <a href=\"https://www.allegro-apts.com/contact-us/\">your ideal home awaits!</a> </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.description": {
    "overrideType": "VALUE",
    "customValue": "<p> <span> <span>Welcome to Allegro, your vibrant oasis in Phoenix, AZ! Choose from our spacious one, two, or three-bedroom <a href=\"https://www.allegro-apts.com/floor-plans/\">apartments</a>, each featuring natural light and modern finishes. Enjoy resort-style <a href=\"https://www.allegro-apts.com/amenities/\">amenities</a> like sparkling pools, a fitness center, and a welcoming clubhouse. Start your new chapter—browse our availability or schedule a tour of our apartments near Desert Botanical Garden today!</span> </span> </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Embrace Life Together in Your New Dream Apartment Community</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "feeguide.aim_code": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_aim_property_code"
  },
  "floor-plans-hero.overline": {
    "overrideType": "VALUE",
    "customValue": "<p>1 - 3 Bedroom Apartments</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.heading": {
    "overrideType": "VALUE",
    "customValue": "<p>Find Your Perfect Home</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to Allegro in sunny Phoenix, AZ, where comfort meets convenience! Choose from stylish one, two, or three-bedroom <a href=\"https://www.allegro-apts.com/floor-plans/\">apartments in Phoenix, AZ</a>, adorned with modern finishes. Dive into our sparkling pools, energize at the fitness center, or unwind on your private patio. Life here is vibrant and full of opportunities for relaxation and connection.&nbsp;</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.overline": {
    "overrideType": "VALUE",
    "customValue": "<p>Experience Lifestyle-Enhancing Features</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Amenities</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p> <span>At Allegro in vibrant Phoenix, AZ, your ideal living space awaits with <span> <a href=\"https://www.allegro-apts.com/floor-plans/\">spacious one, two, and three-bedroom floor plans</a>.</span> Indulge in our two sparkling pools and fitness center, or unwind on your private balcony. With top-notch amenities and professional management, make Allegro your perfect Phoenix apartment today.</span> <span> <span></span> </span> </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Apply Now</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Allegro in sunny Phoenix, AZ, our thoughtfully designed one, two, and three-bedroom <a href=\"https://www.allegro-apts.com/floor-plans/\">floor plans</a> offer the perfect blend of comfort and style. Whether you seek a cozy retreat or a spacious haven, we have <span> <a href=\"https://www.allegro-apts.com/virtual-tour/\">the ideal space for you</a> </span> . Have questions? Contact our leasing team today!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.overline": {
    "overrideType": "VALUE",
    "customValue": "<p>Reach Out to Learn More</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Contact Us</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "faq-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Have questions? We've got answers. Whether you're curious about floor plans, pet policies, or community amenities, we've put together answers to the questions we hear most at Allegro. Don't see what you're looking for? Contact us or stop by, we'd love to show you around. At Allegro in vibrant Phoenix, AZ, we offer a variety of spacious floor plans, including one, two, and three-bedroom apartments designed for your comfort. Curious about our community? Visit our FAQs page to uncover the answers to your most pressing questions and see why Allegro is the perfect place to call home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "faq.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Frequently Asked Questions</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p> <span> <span>At Allegro in vibrant Phoenix, AZ, our thoughtfully designed <a href=\"https://www.allegro-apts.com/\">floor plans</a> cater to every lifestyle with one, two, and three-bedroom options. Each home seamlessly blends comfort and style, inviting you to experience modern living. Browse our available apartment homes in Phoenix, AZ, and uncover the perfect space to call your own!</span> </span> </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Floor Plans</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p> <span> <span>At Allegro in vibrant Phoenix, AZ, our thoughtfully designed floor plans cater to every lifestyle with one, two, and three-bedroom options. Each home seamlessly blends comfort and style, inviting you to experience modern living. Browse our <a href=\"https://www.allegro-apts.com/virtual-tour/\">available apartment homes</a> and uncover the perfect space to call your own!</span> </span> </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Allegro in vibrant Phoenix, AZ, we offer <a href=\"https://www.allegro-apts.com/floor-plans/\">spacious one, two, and three-bedroom apartments</a> near Chase Field, designed for modern living. Picture yourself in a tranquil setting, surrounded by lush landscaping, sparkling pools, and a welcoming clubhouse. With breathtaking views and stylish finishes, your ideal home awaits—don’t just imagine it, live it!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.overline": {
    "overrideType": "VALUE",
    "customValue": "<p>Explore Our Photo Gallery</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Gallery</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>1 - 3 Bedroom Apartments in Phoenix , AZ</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Allegro Apartments</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.overline": {
    "overrideType": "VALUE",
    "customValue": "<p>Ideally Located in Phoenix , AZ</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Neighborhood</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "parallaxbanner.eyebrow": {
    "overrideType": "VALUE",
    "customValue": "<p>Tour Anytime. From Any Distance.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "parallaxbanner.title": {
    "overrideType": "VALUE",
    "customValue": "<p>We're Here For You</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Allegro offers pet-friendly apartments in Phoenix, AZ. Maximum 2 pets per apartment. $300 non‑refundable pet fee. $35 monthly pet rent per pet. Dogs limited to 75 lb. Aggressive breed restrictions apply (e.g., Akita, American Bulldog, Bull/Brazilian Mastiff, Bull Terrier, Boxer, Chow Chow, Dalmatian, Doberman, German Shepherd, Shiba Inu, Great Dane, Pitbull/Stafford Terriers, Rottweiler, Rhodesian Ridgeback, Husky/Malamute/Samoyed, Shar Pei). Exceptions may be made for service animals or emotional support animals.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.overline": {
    "overrideType": "VALUE",
    "customValue": "<p>Living with Your Pet</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Pet Policy</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Pets are welcome! Breed restrictions apply.&nbsp;</p><p>Pet fee: $300 per pet.&nbsp;</p><p>Monthly pet rent: $35 per pet.&nbsp;</p><p>Maximum 2 pets per apartment</p><p>Weight limit is 75 lbs.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Living with Your Pet</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Allegro in vibrant Phoenix, AZ, find your ideal home with our thoughtfully designed <a href=\"https://www.allegro-apts.com/floor-plans/\">one, two, and three-bedroom floor plans.</a> Each space harmonizes comfort and style, perfect for today’s lifestyle. Curious about our community? Schedule a tour today and see what our residents love about living here!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.overline": {
    "overrideType": "VALUE",
    "customValue": "<p>Take a Tour of Allegro Apartments</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Schedule A Tour</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "thankyoucontent.body": {
    "overrideType": "VALUE",
    "customValue": "<p>Thank you for reaching out to Allegro in sunny Phoenix, AZ! We're excited to help you find your perfect home among our diverse floor plans, including one, two, and three bedrooms. Stay tuned—one of our friendly team members will connect with you shortly to assist with your journey.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Experience the vibrant lifestyle at Allegro in sunny Phoenix, AZ. Choose from spacious <a href=\"https://www.allegro-apts.com/floor-plans/\">one, two, or three-bedroom apartment floor plans</a> tailored to your needs. Immerse yourself in our community’s charm and modern <a href=\"https://www.allegro-apts.com/amenities/\">amenities</a> —take a virtual tour today and find your perfect home at Allegro!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.overline": {
    "overrideType": "VALUE",
    "customValue": "<p>Take a Virtual Tour of Our Community</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Virtual Tours</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "propertyoverview.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Find Your Home"
      },
      "url": {
        "type": "VALUE",
        "customValue": "/floor-plans"
      }
    }
  },
  "floorplanslist.contact_cta": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Explore The Area"
      },
      "url": {
        "type": "VALUE",
        "customValue": "/neighborhood"
      }
    }
  },
  "floorplanslist.view_all_cta": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/amenities"
      },
      "label": {
        "type": "VALUE",
        "customValue": "View Amenities"
      }
    }
  },
  "footer.managed_by_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_company_logo"
      },
      "alt": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_company_logo_media.alt_text"
      }
    }
  },
  "header.resident_access_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_resident_portal_url"
      },
      "label": {
        "type": "VALUE",
        "customValue": "Resident Login"
      }
    }
  },
  "header.schedule_tour_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Schedule A Tour"
      }
    }
  },
  "herocallouts.cta1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "View Pricing & Availability"
      },
      "url": {
        "type": "VALUE",
        "customValue": "/floor-plans/"
      }
    }
  },
  "petpolicy.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Explore All Amenities"
      }
    }
  },
  "faq.item1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What floor plans are available at Allegro Apartments?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p>Allegro offers 1, 2, and 3 bedroom apartments for rent in Phoenix, AZ. For additional details, availability, and floor plan pricing, please visit our floor plans page or <a href=\"/contact-us\">contact our leasing team</a>.</p>"
      }
    }
  },
  "faq.item10": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What public transportation options are available near the community?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p>Allegro is located near major Phoenix-area roadways including easy freeway access, providing convenient connections throughout the greater Phoenix metro area. For information on Valley Metro bus and light rail routes serving the area, residents are encouraged to visit the Valley Metro website or <a href=\"/contact-us\">contact the leasing office</a>.</p>"
      }
    }
  },
  "faq.item11": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What do I need to bring with me when applying or touring?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p>For touring, a government-issued photo ID is required. Please contact our leasing office for any additional documentation needed during the application process.</p>"
      }
    }
  },
  "faq.item12": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What are the application and administrative fees?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p>Application Fee: $65 per applicant. Administrative Fee: $300 per unit (non-refundable). A security deposit of $300 to one month's rent is also required at move-in.</p>"
      }
    }
  },
  "faq.item13": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What lease terms are available?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p>Allegro offers lease terms of 9 to 12 months. <a href=\"/contact-us\">Please contact our leasing office</a> for current availability and to find the term that works best for you.</p>"
      }
    }
  },
  "faq.item14": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Is renter insurance required?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p>Renter's insurance is required for residents. In lieu of providing your own HO4 renter's insurance policy, a damage waiver fee of $16.50 per month may be applied. Coverage helps protect your personal belongings and may include liability protection. Please review your lease agreement or <a href=\"/contact-us\">contact the leasing office</a> for specific coverage requirements and minimum policy limits.</p>"
      }
    }
  },
  "faq.item15": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is included in the monthly rent?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p>Monthly rent includes access to your apartment home and community amenities. Additional costs such as utilities, parking upgrades, and pet rent may vary. <a href=\"/contact-us\">Please contact our leasing office</a> for the most accurate and up-to-date breakdown of what is included and any optional monthly costs.</p>"
      }
    }
  },
  "faq.item2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What amenities are included in the apartments and community?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p>Allegro offers community amenities such as two sparkling pools with a jacuzzi and spa, a fitness center, a clubhouse lounge for entertaining and community-sponsored activities, a resident BBQ area, parcel lockers, reserved and covered parking, private garages, a gated community, and Wi-Fi access available in all units and public spaces. Interior features include stainless steel appliances, quartz countertops, washer and dryer in unit, private patios and balconies with storage closets, large walk-in closets, ceiling fans, air conditioning, and more. <a href=\"/amenities\">Visit our amenities page</a> for full details.</p>"
      }
    }
  },
  "faq.item3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Is this property pet-friendly?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p>Yes! Allegro is a pet-friendly apartment community in Phoenix, AZ.</p>"
      }
    }
  },
  "faq.item4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the pet policy & fees?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p>Allegro offers pet-friendly apartments in Phoenix, AZ with a maximum of 2 pets per apartment. Pet fee: $300 per pet (non-refundable). Monthly pet rent: $35 per pet. Dogs are limited to 75 lbs. Breed restrictions apply.</p><p>Restricted breeds include Akita, American Bulldog, Bull/Brazilian Mastiff, Bull Terrier, Boxer, Chow Chow, Dalmatian, Doberman, German Shepherd, Shiba Inu, Great Dane, Pitbull/Staffordshire Terriers, Rottweiler, Rhodesian Ridgeback, and Husky/Malamute/Samoyed. Exceptions may be made for service animals or emotional support animals.</p><p><a href=\"/contact-us\">Please contact our leasing office</a> for more information.</p>"
      }
    }
  },
  "faq.item5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Are EV charging stations available?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p>EV charging stations are not currently listed among Allegro's community amenities. <a href=\"/contact-us\">Please contact our leasing office</a> for the most up-to-date information on EV charging options.</p>"
      }
    }
  },
  "faq.item6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What parking options are available?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p>Allegro offers reserved parking, covered parking, private garages, and guest parking on the property. <a href=\"/contact-us\">Contact the leasing office</a> for details on availability and any associated fees.</p>"
      }
    }
  },
  "faq.item7": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What schools are located near Allegro Apartments?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p>Allegro is located within the Ahwatukee Foothills area of Phoenix. Nearby schools may include those within the Tempe Union High School District and the Kyrene Elementary School District. School assignments may vary by address, so prospective residents are encouraged to confirm current assignments directly with the school district.</p>"
      }
    }
  },
  "faq.item8": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What are the major employers nearby?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p>Allegro is conveniently located near major Phoenix-area employers and business hubs. The community offers easy freeway access to I-10 and nearby employment centers, with proximity to employers throughout the greater Phoenix metro area including healthcare systems, technology companies, and financial services firms concentrated in Chandler, Tempe, and downtown Phoenix.</p>"
      }
    }
  },
  "faq.item9": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What shopping, dining, and entertainment options are nearby?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p>Allegro residents enjoy convenient access to a wide range of shopping, dining, and entertainment options. Nearby destinations include South Mountain Park for outdoor recreation, Oasis Water Park, and Urban Air Trampoline Park. The surrounding Ahwatukee and Chandler area features a variety of local restaurants, retail shops, and entertainment venues, all just a short drive away.</p>"
      }
    }
  },
  "herocallouts.cta2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Take a Virtual Tour"
      },
      "url": {
        "type": "VALUE",
        "customValue": "/virtual-tour/"
      }
    }
  },
  "herocallouts.cta3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Explore Our Amenities"
      },
      "url": {
        "type": "VALUE",
        "customValue": "/amenities/"
      }
    }
  },
  "herocallouts.cta4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Browse The Gallery"
      },
      "url": {
        "type": "VALUE",
        "customValue": "/gallery/"
      }
    }
  },
  "imagecallouts.tile1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019f6699-a3b2-7722-971d-6f7cb6e3b6c6.webp"
      }
    }
  },
  "imagecallouts.tile2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019f6699-a404-7349-89d7-99b2aac5e808.webp"
      }
    }
  },
  "imagecallouts.tile3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019f6699-b6b6-76d6-9e07-9dd93ad9ad95.webp"
      }
    }
  },
  "imagecallouts.tile4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019f6699-b5da-744f-b03a-d2800016999a.webp"
      }
    }
  },
  "parallaxbanner.primary_cta": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Schedule a Visit"
      },
      "url": {
        "type": "VALUE",
        "customValue": "/schedule-a-tour"
      }
    }
  },
  "parallaxbanner.secondary_cta": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Take a Virtual Tour"
      },
      "url": {
        "type": "VALUE",
        "customValue": "/virtual-tour"
      }
    }
  },
  "petpolicy.image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019f7257-87af-70f2-ad65-d37ab0548ae1.webp"
      }
    }
  },
  "socialconnect.image1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019f6699-a3b2-7722-971d-6f7cb6e3b6c6.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Cozy bedroom with a queen-size bed, plush bedding, and a large window with city views."
      }
    }
  },
  "socialconnect.image2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019f6699-a404-7349-89d7-99b2aac5e808.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Billiard table and bar area in the apartment clubhouse lounge."
      }
    }
  },
  "socialconnect.image3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019f7257-8582-75bc-8abb-8aed4c52293f.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Rooftop lounge area with bar, seating, and string lights overlooking city."
      }
    }
  },
  "socialconnect.image4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166423/019f6699-b5da-744f-b03a-d2800016999a.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern dining area with plush seating, large tables, and contemporary chandeliers."
      }
    }
  }
};

export const collectionBindingOverrides = {};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "anyonehome-chatbot",
      "blockId": "anyonehome-chatbot",
      "position": 0
    },
    {
      "sectionId": "lea-chatbot",
      "blockId": "lea-chatbot",
      "position": 0
    }
  ]
};

export const styleOverrides = {};
